export default "__VITE_ASSET__U6_8Wr2G__"